import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "./jsx.js";
import { Icon } from "./Icon.js";
import { history } from "./History.js";
function computeHref(href) {
    if (!href.endsWith("/")) {
        href += "/";
    }
    return href;
}
export function Anchor({ href, title, target, className, children, }) {
    const handleClick = useCallback((e) => {
        if (href.startsWith("/")) {
            e.preventDefault();
            const finalHref = computeHref(href);
            fetch(`${finalHref}meta.json`)
                .then((resp) => resp.text())
                .then((payload) => {
                history().pushState(payload, title || document.title, finalHref);
            });
        }
    }, [href, title]);
    return (_jsx("a", { href: href, onClick: handleClick, target: target || "_self", className: className, children: children }));
}
export function Link({ href, target, className, children, noUnderline, }) {
    return (_jsx(Anchor, { href: href, target: target || "_self", className: `${noUnderline
            ? ""
            : "border-b border-gray-300 hover:border-gray-500 leading-tight inline-block"} ${className || ""}`, children: children }));
}
const sizeToClassName = new Map([
    ["gray-500", "text-gray-700"],
]);
const sizeToFillClassName = new Map([
    ["gray-500", "fill-gray-700"],
]);
export function LinkWithIcon({ icon, title, color = "gray-500", className, ...linkProps }) {
    //TODO: fix this
    const colorClassName = sizeToClassName.get(color);
    const classNameWithColor = `${className || ""} ${colorClassName}`;
    return (_jsxs(Link, { className: `inline-flex items-center ${classNameWithColor}`, ...linkProps, children: [_jsx(Icon, { name: icon, size: "4", className: sizeToFillClassName.get(color) }), _jsx("span", { className: `pl-2`, children: title })] }));
}
